import { HttpErrorResponse, HttpInterceptorFn, HttpResponse } from "@angular/common/http";
import { inject } from "@angular/core";
import { of, throwError } from "rxjs";
import { AppStorage } from "../../utils/app-storage";
import { UserService } from "@main/users/user.service";

export const httpResponseSimulationInterceptor: HttpInterceptorFn = (req, next) => {
    const userService = inject(UserService);
    if (req.url.includes("api/") && !req.url.includes("api/account") && userService && userService.isLogged) {
        const savedHttpSimulatedCode = parseInt(AppStorage.getItem(AppStorage.SimulatedHttpStatusCodeKey));

        if (!Number.isNaN(savedHttpSimulatedCode)) {
            const responseObject = {
                status: savedHttpSimulatedCode,
                url: req.url,
                statusText: "Simulated response."
            };

            if (savedHttpSimulatedCode < 400) {
                return of(new HttpResponse(responseObject));
            } else {
                return throwError(() => new HttpErrorResponse(responseObject));
            }
        }
    }

    return next(req);
};
